import { ShoppingBag } from "lucide-react";
import { brl, dataBR } from "@/lib/api";
import { EmptyState, StatusPill, Surface } from "@/components/ds";

const PAYMENT_LABEL = {
  CONFIRMADO: "Pago",
  PARCIAL: "Parcial",
  PENDENTE: "A receber",
};

/** Só os itens da criadora dentro de cada pedido. Nada do cliente, nada de outros itens. */
export const CreatorSales = ({ data }) => {
  const orders = data.orders || [];
  if (orders.length === 0)
    return (
      <EmptyState
        icon={ShoppingBag}
        title="Nenhuma venda registrada"
        description="Quando um pedido incluir um produto seu, ele aparece aqui."
        testid="creator-sales-empty"
      />
    );

  return (
    <div className="space-y-3" data-testid="creator-sales">
      {orders.map((o) => (
        <Surface key={o.number} className="p-4" data-testid={`creator-sale-${o.number}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div className="min-w-0">
              <p className="font-display text-sm">{o.number}</p>
              <p className="text-[11px] text-muted-foreground">{dataBR(o.created_at)}</p>
            </div>
            <div className="flex flex-wrap items-center gap-1.5">
              <StatusPill tone="info" testid={`creator-sale-status-${o.number}`}>
                {o.status_label}
              </StatusPill>
              <StatusPill tone={o.payment_status === "CONFIRMADO" ? "success" : "warning"}>
                {PAYMENT_LABEL[o.payment_status] || o.payment_status}
              </StatusPill>
            </div>
          </div>
          <ul className="mt-3 space-y-1 text-xs">
            {o.items.map((i, idx) => (
              <li key={idx} className="flex items-center justify-between gap-2">
                <span className="min-w-0 truncate">
                  {i.quantity}x {i.name}
                  {i.variation_name ? ` · ${i.variation_name}` : ""}
                </span>
                <span className="shrink-0 font-num">{brl(i.total)}</span>
              </li>
            ))}
          </ul>
          <div className="mt-3 flex items-center justify-between border-t border-white/10 pt-2 text-xs">
            <span className="text-muted-foreground">Total dos seus itens</span>
            <span className="font-num text-sm">{brl(o.items_total)}</span>
          </div>
        </Surface>
      ))}
    </div>
  );
};
